import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/authSlice';
import UsersSlice from './Slices/UsersSlice';
import settingsReducer from './Slices/SettingsSlice';
import CategoryReducer from './Slices/CategorySlice';
import BannerReducer from './Slices/BannerSlice';
import MainBannerReducer from './Slices/MainBannerSlice';
import VendorReducer from './Slices/VendorSlice';
import DeliveryReducer from './Slices/DeliverySlice';
import ComplaintReducer from './Slices/ComplaintSlice';

import FAQReducer from './Slices/FAQSlice';
import vendorWithdrawalReducer from './Slices/VendorWithdrawalSlice';
import deliveryWithdrawalReducer from './Slices/DeliveryWithdrawalSlice';
import teachersReducer from './Slices/TeachersSlice';
import studyMaterialsReducer from './Slices/StudyMaterialsSlice';
import classRoomsReducer from './Slices/ClassRoomsSlice';
import AdminsSlice from './Slices/AdminsSlice';
import CitiesSlice from './Slices/CitiesSlice';
import FeaturesSlice from './Slices/FeaturesSlice';
import GradesSlice from './Slices/GradesSlice';
import RegionsSlice from './Slices/RegionsSlice';
import ContactReducer from './Slices/ContactSlice';
// إضافة الـ slices الجديدة
import MessageReducer from './Slices/MessageSlice';
import SectionReducer from './Slices/SectionSlice';
import SliderTextReducer from './Slices/SliderTextSlice';
import ProductReducer from './Slices/ProductSlice';
import SliderReducer from './Slices/SliderSlice';
import OrderReducer from './Slices/OrderSlice';
import DashboardReducer from './Slices/DashboardSlice';
import TeachersCodesSlice from './Slices/TeachersCodesSlice';
import CouponsSlice from './Slices/CouponsSlice';

import { apiReducer } from './Slices/api.slice';
import legalReducer from './Slices/LegalPagesSlice';
import WalletReducer from './Slices/WalletSlice';
import ReportsReducer from './Slices/ReportsSlice';
import NotificationsSlice from './Slices/NotificationsSlice';
import VariantReducer from './Slices/VariantSlice';

const store = configureStore({
  reducer: {
    api: apiReducer,
    auth: authReducer,
    settings: settingsReducer,
    categories: CategoryReducer,
    banners: BannerReducer,
    mainBanners: MainBannerReducer,
    vendors: VendorReducer,
    deliveries: DeliveryReducer,
    complaints: ComplaintReducer,
    faqs: FAQReducer,
    vendorWithdrawals: vendorWithdrawalReducer,
    deliveryWithdrawals: deliveryWithdrawalReducer,
    teachers: teachersReducer,
    studyMaterials: studyMaterialsReducer,
    classRooms: classRoomsReducer,
    admins: AdminsSlice,
    cities: CitiesSlice,
    features: FeaturesSlice,
    grades: GradesSlice,
    regions: RegionsSlice,
    contacts: ContactReducer,
    // إضافة الـ reducers الجديدة
    messages: MessageReducer,
    sections: SectionReducer,
    sliderTexts: SliderTextReducer,
    users: UsersSlice,
    products: ProductReducer,
    sliders: SliderReducer,
    orders: OrderReducer,
    dashboard: DashboardReducer,
    teachers_codes: TeachersCodesSlice,
    coupons: CouponsSlice,
    legal: legalReducer,
    wallets: WalletReducer,
    reports: ReportsReducer,
    notifications: NotificationsSlice,
    variants: VariantReducer,
  },
});

export default store;
